<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <sale-market-head></sale-market-head>
      <div class="list-search">
        <loading v-if="search_result == null" :text="'Please wait'|translate"></loading>

        <div class="mt20" v-if="search_result != null">
          <div
            v-if="search_result.length== 0"
            class="alert alert-info"
            role="alert"
          >{{'No result'|translate}}</div>

          <ul class="list-group" v-if="search_result.length > 0">
            <li class="list-group-item" v-for="(store) in search_result" :key="store.id">
              <router-link
                :to="{ name: 'SaleMarketStore', params: { store_id: store.store_id }}"
              >{{store.store_name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "Search",
  components: {
    MyHeader,
    Loading,
    SaleMarketHead
  },
  data() {
    return {
      search_result: null
    };
  },
  computed: {},
  methods: {
    strippedContent(html) {
      let regex = /(<([^>]+)>)/gi;
      return html.replace(regex, "");
    },
    roundNumber(number) {
      return Math.round(number * 100) / 100;
    }
  },
  mounted() {
    Utils.request(this, true, "store")
      .get(`/favoriteList/`)
      .then(response => {
        this.search_result = response.data.data;
        // console.log("this.search_result", this.search_result);
      })
      .catch(error => {});
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/FavoriteStores.vue